/********************************************************************************
 * Copyright (c) 2024 T-Systems International GmbH
 * Copyright (c) 2024 Contributors to the Eclipse Foundation
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Apache License, Version 2.0 which is available at
 * https://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 *
 * SPDX-License-Identifier: Apache-2.0
 ********************************************************************************/

import { ReactChild, ReactFragment } from 'react';

import customConfig from '../assets/customConfig/custom-config.json';
import PageNotFound from '../pages/PageNotFound';

const RouteCheck = ({
  value,
  pageNotFound,
  children,
}: {
  value: string;
  pageNotFound?: ReactFragment;
  children: ReactChild;
}) => {
  const existsInArray = customConfig?.restrictedRoutes?.includes(value);
  if (!existsInArray) return <>{children}</>;
  else if (pageNotFound) return <PageNotFound />;
  else return null;
};
export default RouteCheck;
